import {Component, EventEmitter, OnInit, AfterViewInit, Output, ViewChild} from "@angular/core";
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from "rxjs";
import { NdmsInputComponent } from "../../../../../shared/ui-ndms/forms/ndms-input/ndms-input.component";
import { NdmsFormControlComponent } from "../../../../../shared/ui-ndms/forms/ndms-form-control/ndms-form-control.component";
import { NdmsSelectComponent } from "../../../../../shared/ui-ndms/forms/ndms-select/ndms-select.component";
import { HasFormComponent } from "../../../../../shared/core/interfaces/hasFormComponent";
import { Router, ActivatedRoute } from "@angular/router";
import { LookupService } from "../../../../../shared/core/services/lookup.service";
import { FormGroup, FormControl, Validators, FormBuilder } from "@angular/forms";
import { FormObjects } from "../../../../../shared/core/utilities/formObjects";
import { ViewModelService } from "../../../../../shared/core/services/view-model.service";
import { NotImplementedViewModel } from "../../../../../shared/ui-ndms/view-models/not-implemented.view-model";
import { PatientHomeService } from "../shared/services/patient-home.service"
import { LazyLoadEvent } from "primeng/api";
import * as moment from "moment";
import {Subscription} from "rxjs";
import {AuthApiService} from "../../../shared/core-jpats/services/auth.service";
import {DatetimeService} from "../../../shared/services/datetime.service";

@Component({
  selector: "patients-search",
  templateUrl: "./patients-search.component.html",
  styleUrls: ["./patients-search.component.scss"]
})
export class PatientsSearchComponent extends HasFormComponent<NotImplementedViewModel> implements OnInit, AfterViewInit {

  private _count$ = new BehaviorSubject<number>(0);
  get count$() {
    return this._count$.asObservable();
  }
  get count() {
    return this._count$.value;
  }

  authSubscription: Subscription;
  resetPatientSearchSubscription: Subscription;
  searchResults: any[] = [];
  isSearching: boolean = false;
  firstItem: number = 0;

  @ViewChild(NdmsSelectComponent) genderField: NdmsSelectComponent;
  @Output() public cancel = new EventEmitter();
  pagingData: any = {
    rows: 10,
    pageNumber: 1,
    totalCount: 0
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _title: Title,
    lookupService: LookupService,
    viewModelService: ViewModelService,
    private patientHomeService: PatientHomeService,
    public dateTimeService:DatetimeService,
    private authApiService: AuthApiService,
  ) {
    super(lookupService, viewModelService, NotImplementedViewModel, false);

    this.form = new FormGroup({
      firstName: FormObjects.String(),
      lastName: FormObjects.String(),
      birthDate: FormObjects.String(),
      gender: FormObjects.Lookup(),
      identifierNumber:FormObjects.String()
    });
    this.resetPatientSearchSubscription = this.authApiService.resetPatientSearch.subscribe(()=>{
      this.isSearching = false;
      this.cancel.emit();
    });
  }

  ngOnInit() {
    this._title.setTitle("Search Patients Patients - JPATS");

    this.checkLocalStoragePage();
  }

  ngAfterViewInit() {
    this.checkLocalStorage();
    this.onSearchSubmit();
  }

  onSearchSubmit(reset?) {
    if (reset) {
      this.pagingData.pageNumber = 1;
      this.firstItem = 0;
    }
    if (!this.form.valid) {
      this.touchAllFields();
      return;
    }
    let searchCriteria: any = this.form.value;
    searchCriteria.pageNumber = this.pagingData.pageNumber;
    searchCriteria.pageSize = this.pagingData.rows;
    this.patientHomeService.searchPatientsResults(searchCriteria).subscribe((viewModel) => {
      this.searchResults = viewModel.model || [];
      this._count$.next(viewModel.pagingData.totalCount);
      this.isSearching = true;
      this.pagingData.totalCount = (viewModel.pagingData || {}).totalCount;
    });
  }

  onBackClick() {
    this.isSearching = false;
    window.localStorage.removeItem("SearchKeys");
    this._title.setTitle("Patients - JPATS");
    this.cancel.emit('');
  }

  ngOnDestroy(){
    this.resetPatientSearchSubscription.unsubscribe();
  }

  onPageChanged(event: LazyLoadEvent): void {
    this.firstItem = event.first;
    let pageNumber = Math.round(this.firstItem / event.rows) + 1;
    this.pagingData.rows = event.rows;
    this.pagingData.pageNumber = pageNumber;
    this.onSearchSubmit();
  }

  setSearchLoad() {
    let searchKeys: string = "50" + "|" +   //50 identifies this page's session storage (other instances in JPATS will be 51 52 etc)
      (this.form.get("firstName").value || null) + "|" +
      (this.form.get("lastName").value || null) + "|" +
      (this.form.get("birthDate").value || null) + "|" +
      (this.form.get("gender").value?.key || null) + "|" +
      (this.form.get("identifierNumber").value || null) + "|" +
      this.pagingData.pageNumber + "|" +
      this.firstItem + "|" +
      this.pagingData.rows;

    window.localStorage.setItem("SearchKeys", searchKeys);

    //tell patients-home.component to load in Search mode
    window.localStorage.setItem("JpatsPatientSearch", "true");
  }

  //this needs to run AFTER view init, otherwise sex (a dropdown) isn't populated w/ options
  private checkLocalStorage() {
    let searchKeys: string = window.localStorage.getItem("SearchKeys");
    if (searchKeys) {
      let searchKeyGroup: string[] = searchKeys.split("|");
      if (searchKeyGroup[0] == "50") { // JPATS Patient search is identified by 50

        if (searchKeyGroup[1] != "null") this.form.get("firstName").reset(searchKeyGroup[1]);
        if (searchKeyGroup[2] != "null") this.form.get("lastName").reset(searchKeyGroup[2]);
        if (searchKeyGroup[3] != "null") this.form.get("birthDate").reset(searchKeyGroup[3]);
        if (searchKeyGroup[4] != "null") {
          this.genderField.setSelection(searchKeyGroup[4]);
        }
        if (searchKeyGroup[5] != "null") this.form.get("identifierNumber").reset(searchKeyGroup[5]);

        window.localStorage.removeItem("SearchKeys");
      }
    }
  }

  //this needs to run BEFORE view init
  private checkLocalStoragePage() {
    let searchKeys: string = window.localStorage.getItem("SearchKeys");
    if (searchKeys) {
      let searchKeyGroup: string[] = searchKeys.split("|");
      if (searchKeyGroup[0] == "50") { // JPATS Patient search is identified by 50
        if (searchKeyGroup[6] != "null") this.pagingData.pageNumber = searchKeyGroup[6];
        if (searchKeyGroup[7] != "null") this.firstItem = +searchKeyGroup[7];
        if (searchKeyGroup[8] != "null") this.pagingData.rows = +searchKeyGroup[8];
      }
    }
  }
}
